import { Plus, LogOut, ArrowRight, Workflow, Box, Group, LayoutGrid, Send, Sparkles, Upload, FileText, User, Database, Server, Check } from "lucide-react";

function Frame({ children, className = "" }) {
  return (
    <div
      data-testid="help-article-preview"
      className={`rounded-lg border border-slate-200 bg-white p-4 overflow-hidden ${className}`}
    >
      {children}
    </div>
  );
}

function SignupPreview() {
  return (
    <Frame>
      <div className="max-w-[220px] mx-auto rounded-lg border border-slate-200 p-4 space-y-2.5">
        <div className="h-2.5 w-20 bg-slate-800 rounded" />
        <div className="h-7 rounded border border-slate-300 bg-slate-50" />
        <div className="h-7 rounded border border-slate-300 bg-slate-50" />
        <div className="h-7 rounded bg-blue-600 flex items-center justify-center text-white text-[10px] font-semibold">Create Account</div>
      </div>
    </Frame>
  );
}

function DashboardPreview() {
  return (
    <Frame>
      <div className="flex items-center justify-between mb-3">
        <div className="h-2 w-16 bg-slate-300 rounded" />
        <div className="h-6 px-2.5 rounded bg-blue-600 text-white text-[10px] font-semibold flex items-center gap-1">
          <Plus size={10} /> New Project
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {[0, 1, 2].map((i) => (
          <div key={i} className="rounded border border-slate-200 p-2 space-y-1.5">
            <div className="h-1.5 w-10 bg-slate-300 rounded" />
            <div className="h-1.5 w-7 bg-slate-200 rounded" />
          </div>
        ))}
      </div>
    </Frame>
  );
}

function CanvasPreview() {
  return (
    <Frame>
      <div className="flex items-center justify-center gap-6 py-4">
        <div className="rounded border-2 border-amber-400 bg-amber-50 px-3 py-2 text-[10px] font-semibold text-amber-800">Customer</div>
        <ArrowRight size={16} className="text-slate-400" />
        <div className="rounded border-2 border-blue-400 bg-blue-50 px-3 py-2 text-[10px] font-semibold text-blue-800 flex items-center gap-1">
          <Workflow size={11} /> Order Process
        </div>
      </div>
    </Frame>
  );
}

function GroupingPreview() {
  return (
    <Frame>
      <div className="flex items-center justify-between">
        <div className="rounded-lg border-2 border-dashed border-slate-400 bg-slate-100/70 p-2.5 flex gap-2">
          <div className="rounded border border-emerald-400 bg-emerald-50 px-2 py-1.5 text-[9px] font-semibold text-emerald-800 flex items-center gap-1">
            <Box size={10} /> CRM
          </div>
          <div className="rounded border border-emerald-400 bg-emerald-50 px-2 py-1.5 text-[9px] font-semibold text-emerald-800 flex items-center gap-1">
            <Box size={10} /> Billing
          </div>
        </div>
        <div className="h-6 px-2 rounded border border-slate-300 bg-slate-50 text-[9px] font-semibold text-slate-600 flex items-center gap-1 ml-3">
          <LayoutGrid size={10} /> Tidy Up
        </div>
      </div>
      <div className="mt-2 flex items-center gap-1 text-[9px] text-slate-400">
        <Group size={10} /> Group Selected
      </div>
    </Frame>
  );
}

function ChatPreview() {
  return (
    <Frame>
      <div className="space-y-2 max-w-[260px] mx-auto">
        <div className="flex justify-end">
          <div className="rounded-lg bg-blue-600 text-white text-[10px] px-2.5 py-1.5 max-w-[80%]">Add a payment gateway component</div>
        </div>
        <div className="flex justify-start gap-1.5">
          <Sparkles size={12} className="text-purple-500 mt-1 shrink-0" />
          <div className="rounded-lg bg-slate-100 text-slate-700 text-[10px] px-2.5 py-1.5 max-w-[80%]">
            I'll add an Application Component named "Payment Gateway". Approve?
          </div>
        </div>
        <div className="flex gap-1.5 justify-start pl-5">
          <div className="h-5 px-2 rounded bg-emerald-600 text-white text-[9px] font-semibold flex items-center">Approve</div>
          <div className="h-5 px-2 rounded border border-slate-300 text-[9px] font-semibold text-slate-500 flex items-center">Reject</div>
        </div>
      </div>
    </Frame>
  );
}

function ImportPreview() {
  return (
    <Frame>
      <div className="max-w-[240px] mx-auto rounded-lg border-2 border-dashed border-slate-300 py-5 flex flex-col items-center gap-1.5">
        <Upload size={18} className="text-slate-400" />
        <span className="text-[10px] text-slate-500 font-medium">Drop your .archimate file</span>
        <span className="text-[9px] text-slate-400">or paste a text description</span>
      </div>
    </Frame>
  );
}

function ReportPreview() {
  return (
    <Frame>
      <div className="flex items-center gap-3 justify-center">
        <div className="w-16 h-20 rounded border border-slate-300 bg-slate-50 p-1.5 space-y-1">
          <FileText size={12} className="text-slate-400" />
          <div className="h-1 w-full bg-slate-200 rounded" />
          <div className="h-1 w-full bg-slate-200 rounded" />
          <div className="h-1 w-3/4 bg-slate-200 rounded" />
        </div>
        <div className="space-y-1.5 text-[9px] text-slate-500">
          <div className="flex items-center gap-1.5">
            <span className="h-2 w-2 rounded-full bg-emerald-500" /> Live
          </div>
          <div className="flex items-center gap-1.5">
            <span className="h-2 w-2 rounded-full bg-amber-500" /> Test
          </div>
          <div className="flex items-center gap-1.5">
            <span className="h-2 w-2 rounded-full bg-slate-400" /> Dev
          </div>
        </div>
      </div>
    </Frame>
  );
}

function SimpleViewPreview() {
  const cats = [
    { label: "User", icon: User, bg: "#EDE9FE", border: "#8B5CF6", text: "#4C1D95" },
    { label: "System", icon: Box, bg: "#D1FAE5", border: "#10B981", text: "#064E3B" },
    { label: "Data", icon: Database, bg: "#FEF3C7", border: "#F59E0B", text: "#78350F" },
    { label: "Infra", icon: Server, bg: "#E2E8F0", border: "#64748B", text: "#1E293B" },
  ];
  return (
    <Frame>
      <div className="flex items-center justify-center gap-2.5 flex-wrap">
        {cats.map((c) => (
          <div
            key={c.label}
            className="rounded-md border-2 px-2.5 py-1.5 text-[9px] font-semibold flex items-center gap-1"
            style={{ background: c.bg, borderColor: c.border, color: c.text }}
          >
            <c.icon size={10} /> {c.label}
          </div>
        ))}
      </div>
    </Frame>
  );
}

function AdminPreview() {
  return (
    <Frame>
      <div className="max-w-[300px] mx-auto rounded border border-slate-200 overflow-hidden">
        <div className="bg-slate-50 px-2.5 py-1.5 flex text-[9px] font-semibold text-slate-400 uppercase">
          <span className="flex-1">User</span>
          <span className="w-16">Tier</span>
        </div>
        <div className="px-2.5 py-2 flex items-center border-t border-slate-100">
          <span className="flex-1 text-[10px] text-slate-700">jane@company.com</span>
          <span className="text-[9px] bg-slate-100 text-slate-500 px-1.5 py-0.5 rounded-full mr-2">Free</span>
          <span className="h-5 px-2 rounded border border-slate-300 text-[8px] font-semibold text-slate-600 flex items-center gap-1 whitespace-nowrap">
            <Check size={8} /> Promote
          </span>
        </div>
      </div>
    </Frame>
  );
}

const PREVIEWS = {
  signup: SignupPreview,
  dashboard: DashboardPreview,
  canvas: CanvasPreview,
  grouping: GroupingPreview,
  chat: ChatPreview,
  import: ImportPreview,
  report: ReportPreview,
  simpleview: SimpleViewPreview,
  admin: AdminPreview,
};

export function HelpArticlePreview({ preview }) {
  const Component = PREVIEWS[preview];
  if (!Component) return null;
  return <Component />;
}
